import { ACTION_TYPE } from './actionTypes';

const { FATCA_CRS } = ACTION_TYPE;

/** @todo use this to populate fatca to all "no" when customer is kuwaiti and country of birth is Kuwait */
const autoUpdateFatca = () => ({
  type: FATCA_CRS.AUTO_UPDATE_FATCA,
});

const updateFatca = (name, value) => ({
  type: FATCA_CRS.UPDATE_FATCA,
  payload: { name, value },
});

const clearFatcaQ2Q6 = () => ({
  type: FATCA_CRS.CLEAR_FATCA_DATA_EXCEPT_Q1,
});

const updateCrs = (name, value) => ({
  type: FATCA_CRS.UPDATE_CRS,
  payload: { name, value },
});

const saveCountryTax = payload => ({
  type: FATCA_CRS.UPDATE_TAX_LIST,
  payload,
});

const fetchFatcaCrs = obj => (dispatch, getState) => {
  const { fatca, crs, countryTax } =     getState().applicantRootReducer.fatcaCrsReducer;
  dispatch({
    type: FATCA_CRS.FETCH_FATCA_CRS,
    payload: {
      fatca: Object.assign(fatca, obj.fatca),
      crs: Object.assign(crs, obj.crs),
      countryTax: Object.assign(countryTax, obj.countryTax),
    },
  });
};

/**
 * Add more Tax jurisdiction
 */
const addMoreCountryTax = () => (dispatch, getState) => {
  const { countryTax } = getState().applicantRootReducer.fatcaCrsReducer;

  const newList = {
    id: `tax-${countryTax.length + 1}`,
    countryJurisdiction: '',
    isTin: '',
    tin: '',
    reasonOption: '',
    reasonNotIssued: '',
  };

  const combinedList = [...countryTax, newList];

  dispatch(saveCountryTax(combinedList));
};

const updateCountryTax = (index, key, value) => (dispatch, getState) => {
  const { countryTax } = getState().applicantRootReducer.fatcaCrsReducer;

  const objIndex = countryTax.findIndex((x, i) => i === index);
  const newArr = [...countryTax];
  newArr[objIndex] = { ...newArr[objIndex], [key]: value };

  dispatch(saveCountryTax(newArr));
};

const removeCountryTaxItem = id => (dispatch, getState) => {
  const { countryTax } = getState().applicantRootReducer.fatcaCrsReducer;
  const filteredArr = countryTax.filter(x => x.id !== id);
  dispatch(saveCountryTax(filteredArr));
};

const fatcaCrsAction = {
  fetchFatcaCrs,
  clearFatcaQ2Q6,
  updateFatca,
  updateCrs,

  addMoreCountryTax,
  updateCountryTax,
  removeCountryTaxItem,

  autoUpdateFatca,
};

export default fatcaCrsAction;
